import {
  File,
  FileArchive,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo,
  PenTool,
} from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * En una carpeta con 300 archivos, el icono es lo primero que el ojo procesa.
 * Los formatos propios del sector (DWG, DXF, BC3) tienen icono y color propios
 * en lugar de caer en el genérico, que es donde se pierden.
 */
const MAP: Record<string, { icon: typeof File; className: string }> = {
  dwg: { icon: PenTool, className: 'text-info bg-info-soft' },
  dxf: { icon: PenTool, className: 'text-info bg-info-soft' },
  bc3: { icon: FileSpreadsheet, className: 'text-warning bg-warning-soft' },
  pzh: { icon: FileSpreadsheet, className: 'text-warning bg-warning-soft' },
  pdf: { icon: FileText, className: 'text-danger bg-danger-soft' },
  doc: { icon: FileText, className: 'text-info bg-info-soft' },
  docx: { icon: FileText, className: 'text-info bg-info-soft' },
  xls: { icon: FileSpreadsheet, className: 'text-success bg-success-soft' },
  xlsx: { icon: FileSpreadsheet, className: 'text-success bg-success-soft' },
  csv: { icon: FileSpreadsheet, className: 'text-success bg-success-soft' },
  jpg: { icon: FileImage, className: 'text-brand bg-brand-soft' },
  jpeg: { icon: FileImage, className: 'text-brand bg-brand-soft' },
  png: { icon: FileImage, className: 'text-brand bg-brand-soft' },
  heic: { icon: FileImage, className: 'text-brand bg-brand-soft' },
  mp4: { icon: FileVideo, className: 'text-brand bg-brand-soft' },
  mov: { icon: FileVideo, className: 'text-brand bg-brand-soft' },
  zip: { icon: FileArchive, className: 'text-fg-muted bg-surface-3' },
  rar: { icon: FileArchive, className: 'text-fg-muted bg-surface-3' },
};

export function FileIcon({
  extension,
  size = 'md',
  className,
}: {
  extension: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const entry = MAP[extension?.toLowerCase() ?? ''] ?? {
    icon: File,
    className: 'text-fg-muted bg-surface-3',
  };
  const Icon = entry.icon;

  const box = { sm: 'size-7', md: 'size-9', lg: 'size-11' }[size];
  const glyph = { sm: 'size-3.5', md: 'size-4.5', lg: 'size-5' }[size];

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-lg',
        box,
        entry.className,
        className,
      )}
      aria-hidden
    >
      <Icon className={glyph} />
    </span>
  );
}
